import '../static/Video.css';
import React__default, { forwardRef, useState, useRef, useCallback, useEffect, useImperativeHandle } from "react";
import clsx from "clsx";
const video = `_video_58219b3`;
const contain = `_contain_86e1f12`;
const cover = `_cover_7f605d3`;
const none = `_none_278705d`;
const styles = { video, contain, cover, none };
const VideoInner = ({
  autoPlay,
  className,
  controls = true,
  objectFit = "none",
  url,
  mime = "video/mp4",
  play,
  ...props
}, ref) => {
  const [isReady, setIsReady] = useState(false);
  const innerRef = useRef(null);
  const playVideo = useCallback(() => {
    var _a;
    (_a = innerRef.current) == null ? void 0 : _a.play();
  }, []);
  const pauseVideo = useCallback(() => {
    var _a;
    (_a = innerRef.current) == null ? void 0 : _a.pause();
  }, []);
  useEffect(() => {
    if (autoPlay) {
      return;
    }
    if (play) {
      playVideo();
    } else {
      pauseVideo();
    }
  }, [autoPlay, play, pauseVideo, playVideo]);
  useImperativeHandle(ref, () => innerRef.current, []);
  return /* @__PURE__ */ React__default.createElement(
    "video",
    {
      ...props,
      "data-ready": isReady,
      className: clsx(styles.video, styles[objectFit], className),
      ref: innerRef,
      playsInline: true,
      disablePictureInPicture: true,
      controlsList: "nodownload noremoteplayback",
      controls,
      autoPlay,
      onCanPlay: (e) => {
        setIsReady(true);
        play && playVideo();
        if (props.onCanPlay) {
          props.onCanPlay(e);
        }
      }
    },
    /* @__PURE__ */ React__default.createElement("source", { src: url, type: mime })
  );
};
const Video = forwardRef(VideoInner);
export {
  Video
};
//# sourceMappingURL=Video.D1vGv3n9.mjs.map
